/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyExecutionRequest {
    getFixupPrototypeFunction() { return PolicyExecutionRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyExecutionRequest>): PolicyExecutionRequest {
        let obj = Object.assign(new PolicyExecutionRequest(), model);
        PolicyExecutionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyExecutionRequest>): PolicyExecutionRequest {
        if (!model) return null;
        return PolicyExecutionRequest.newInstance(<PolicyExecutionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyExecutionRequest) {
        if (!obj) return;

        models.PolicyExecutionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyExecutionRequest): boolean {
        Object.setPrototypeOf(obj, PolicyExecutionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique URI for the policy
     */
    policy_uri: string;

    /**
     * Account to execute the policy against
     */
    cloud_account_id: string;

    /**
     * Policy execution parameters, encoded as a JSON string
     */
    params: string;

    /**
     * Policy execution group name
     */
    execution_group: string;

    /**
     * Policy execution reference ID
     */
    execution_reference: string;

}
